<div fxLayout>
  <sbnb-subnav fxFlex="280px" fxHide.lt-md [header]="'SETTINGS.SETTINGS' | transloco">
    <sbnb-settings-subnav></sbnb-settings-subnav>
  </sbnb-subnav>

  <main fxFlex class="subnav__exists" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <h2 fxLayout fxLayoutAlign="space-apart center">
      <span fxFlex>Subscribe to {{ 'CORE.PRODUCT_NAME' | transloco }}</span>
    </h2>

    <hr />

    <mat-spinner *ngIf="loading" style="margin-top: 24px" [diameter]="32"></mat-spinner>

    <ng-container *ngIf="!loading">
      <div class="outer__card-container" [class.clickable]="stage > 1">
        <div
          class="inner__card-container"
          fxLayout
          fxLayoutAlign="start center"
          fxLayoutGap="12px"
          (click)="stage > 1 ? returnToStage(1) : null">
          <img
            [src]="stage > 1 ? '/assets/iconography/subtotal-grass.svg' : '/assets/iconography/subtotal.svg'"
            alt="Billing details icon" />
          <h4>Billing Details</h4>
        </div>
        <div class="inner__card-content" [hidden]="stage !== 1">
          <sbnb-billing-form [embedded]="true" (saved)="billingSaved($event)"></sbnb-billing-form>
        </div>
      </div>

      <div class="outer__card-container" [class.clickable]="stage > 2">
        <div
          class="inner__card-container"
          fxLayout
          fxLayoutAlign="start center"
          fxLayoutGap="12px"
          (click)="stage > 2 ? returnToStage(2) : null">
          <img
            [src]="stage > 2 ? '/assets/iconography/credit-card.svg' : '/assets/iconography/credit-card-grey.svg'"
            alt="Payment details icon" />
          <h4>Payment Methods</h4>
        </div>
        <div class="inner__card-content" [hidden]="stage !== 2">
          <div class="subscribe__hero">
            <sbnb-your-plan-hero-item>Your subscription will renew every month.</sbnb-your-plan-hero-item>
            <sbnb-your-plan-hero-item *ngIf="subscriptionData.status === 'trialing'">
              Your payment cycle will start on
              <strong>{{ subscriptionData.trial_end | date: 'mediumDate' }}</strong>
              .
            </sbnb-your-plan-hero-item>
            <sbnb-your-plan-hero-item *ngIf="subscriptionData.status !== 'trialing'">
              Your payment cycle will start
              <strong>immediately</strong>
              .
            </sbnb-your-plan-hero-item>
            <sbnb-your-plan-hero-item>
              You'll be charged
              <strong>{{ subscriptionData.monthly_rate }}</strong>
              for
              <strong>{{ subscriptionData.active_properties }} active properties</strong>
              (where there was at least one check-in in the past 30 days).
              <!-- Taxes -->
              <ng-container *ngIf="subscriptionData.taxes as taxes">
                <div *ngFor="let tax of taxes" class="text__small mt-2 italic">
                  Includes {{ tax.amount }} {{ tax.name }} in {{ subscriptionData.country }}
                </div>
              </ng-container>
            </sbnb-your-plan-hero-item>

            <sbnb-your-plan-hero-item>
              Your subscription is
              <strong>variable</strong>
              and will adapt depending on the number of active properties under your account.
            </sbnb-your-plan-hero-item>
          </div>
          <sbnb-payment-cards [embedded]="true" (saved)="paymentSaved($event)"></sbnb-payment-cards>
        </div>
      </div>

      <div class="outer__card-container">
        <div class="inner__card-container" fxLayout fxLayoutAlign="start center" fxLayoutGap="12px">
          <sbnb-icon icon="details" class="smoke-darker"></sbnb-icon>
          <h4>Summary</h4>
        </div>
        <div class="inner__card-content" [hidden]="stage !== 3">
          <div class="subscribe__hero">
            <sbnb-your-plan-hero-item>Your subscription will renew every month.</sbnb-your-plan-hero-item>
            <sbnb-your-plan-hero-item *ngIf="subscriptionData.status === 'trialing'">
              Your payment cycle will start on
              <strong>{{ subscriptionData.trial_end | date: 'mediumDate' }}</strong>
              .
            </sbnb-your-plan-hero-item>
            <sbnb-your-plan-hero-item *ngIf="subscriptionData.status !== 'trialing'">
              Your payment cycle will start
              <strong>immediately</strong>
              .
            </sbnb-your-plan-hero-item>
            <sbnb-your-plan-hero-item>
              You'll be charged
              <strong>{{ subscriptionData.monthly_rate }}</strong>
              for
              <strong>{{ subscriptionData.active_properties }} active properties</strong>
              (where there was at least one check-in in the past 30 days).

              <!-- Taxes -->
              <ng-container *ngIf="subscriptionData.taxes as taxes">
                <div *ngFor="let tax of taxes" class="text__small mt-2 italic">
                  Includes {{ tax.amount }} {{ tax.name }} in {{ subscriptionData.country }}
                </div>
              </ng-container>
            </sbnb-your-plan-hero-item>

            <sbnb-your-plan-hero-item>
              Your subscription is
              <strong>variable</strong>
              and will adapt depending on the number of active properties under your account.
            </sbnb-your-plan-hero-item>
            <sbnb-your-plan-hero-item>
              Invoices for
              <strong>{{ user.company ? user.company : user.first_name + ' ' + user.last_name }}</strong>
              will be sent to
              <strong>{{ user.email }}</strong>
              .
            </sbnb-your-plan-hero-item>
            <sbnb-your-plan-hero-item
              *ngIf="!stashedNewPaymentMethod && subscriptionData.active_payment_method?.type === 'card'">
              Your payment method is
              <strong>
                {{ subscriptionData.active_payment_method?.brand }} ending in
                {{ subscriptionData.active_payment_method?.last4 }}
              </strong>
              .
            </sbnb-your-plan-hero-item>
          </div>
          <div fxLayout fxLayoutAlign="end center" fxLayoutGap="26px">
            <button mat-flat-button class="button__text" [routerLink]="['/settings/your-plan']">Cancel</button>
            <button [disabled]="subscribing" mat-flat-button (click)="finaliseSubscription()">
              <mat-spinner *ngIf="subscribing" [diameter]="30" class="button__spinner"></mat-spinner>
              <span>Confirm & Subscribe</span>
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </main>
</div>

<sbnb-mobile-sidebar [title]="'Settings'">
  <sbnb-settings-subnav></sbnb-settings-subnav>
</sbnb-mobile-sidebar>
